import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { EpostLetterResource } from "src/admin/modules/epost-letter/types.ts";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { formatDateTimeInZone } from "@exonn/utils";

const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.EpostLetter,
});

export const module: ModuleOptions<EpostLetterResource> = {
  resource: ResourceEnum.EpostLetter,
  bigIcon: <span className={"icon-20-email"} />,
  smallIcon: <span className={"icon-15-email"} />,
  // Новое письмо — мастер «Brief senden»; удалять письма нельзя.
  disableDelete: true,
  create: {
    routeObject: {
      path: routePaths.create.root,
      lazy: () =>
        import("src/admin/modules/epost-letter/routes/create/wizard.route.tsx"),
    },
  },
  tabs: { edit: { getTitle: (letter) => letterTabTitle(letter) } },
};

// Писем одному получателю много: без времени вкладки не различить. Пояс во вкладке лишний.
const letterTabTitle = (letter: EpostLetterResource): string =>
  [
    letter.recipient?.name,
    letter.created_at
      ? formatDateTimeInZone(letter.created_at).split(" ").slice(0, 2).join(" ")
      : null,
  ]
    .filter(Boolean)
    .join(" · ");
